import jquery from 'jquery';
import Handlebars from "handlebars"
import MatchHeight from 'matchheight';

// Handlebars.
window.Handlebars = Handlebars
// jQuery.
window.jQuery = jquery
window.$ = jquery
// Match height
window.MatchHeight = MatchHeight



// Shopify

/*
 * Simple helper to stringify an object.
 * Usage: {{ JSON2string object }}
 */
Handlebars.registerHelper('JSON2string', function (object) {
    return JSON.stringify(object);
});

/*
 * Shopify image sizer.
 * Usage: {{ imageSize imageObject Size }}
 */
Handlebars.registerHelper('imageSize', function (src, size) {
    
    if (src) {
        let f = src.substring(0, src.lastIndexOf('.'));
        let p = src.split('.').pop()
        return f + '_' + size + "." + p;
    }

});

/*
* Contains string
*/
Handlebars.registerHelper('contains', function(needle, haystack, options) {
    needle = Handlebars.escapeExpression(needle)
    haystack = Handlebars.escapeExpression(haystack);
    return (haystack.indexOf(needle) > -1) ? options.fn(this) : options.inverse(this)
});

/*
* Badge text augmentation (splitting)
*/
Handlebars.registerHelper('tagText', function (str) {
    str = str.split('_')
    return str[1]
});

/*
* Badge colour augmentation (to match tailwind css classes)
*/
Handlebars.registerHelper('tagColour', function (str, needle) {
    
        str = str.split('_')

        str = str[0].split(needle)
        if (str[1] == 'Black' || str[1] == 'White' || str[1] == 'Blue') {
            str[1] = 'Brand-' + str[1];
        }
        if (typeof str[1] !== 'undefined') {
            return str[1].toLowerCase()
        }
    
});

